import * as React from 'react'

function SvgComponent({
  color,
  isFill,
  props,
}: {
  color: string
  isFill: boolean
  props?: React.SVGProps<SVGSVGElement>
}) {
  return (
    <svg
      width={104}
      height={144}
      viewBox="0 0 104 144"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isFill ? (
        <>
          <g filter="url(#filter3_concave)" fill={color}>
            <path d="M99.812 130.698c-16.904 16.628-78.72 16.628-95.624 0-10.623-10.449 2.315-34.78 2.315-59.116S-6.435 22.92 4.188 12.472c16.905-16.63 78.72-16.63 95.624 0 10.623 10.448-2.315 34.779-2.315 59.115s12.938 48.657 2.315 59.111z" />
            <path
              d="M52.002 133.714c-18.687 0-35.936-4.156-41.945-10.111-2.705-2.678-.56-13.248 1.332-22.575 1.806-8.906 3.854-18.998 3.854-29.444 0-10.445-2.048-20.537-3.854-29.443-1.892-9.327-4.037-19.897-1.332-22.575C16.066 13.61 33.315 9.455 52.002 9.455s35.937 4.156 41.941 10.11c2.705 2.684.56 13.25-1.331 22.576-1.807 8.906-3.855 18.998-3.855 29.444 0 10.445 2.048 20.537 3.855 29.443 1.89 9.327 4.036 19.897 1.331 22.575-6.004 5.955-23.254 10.111-41.94 10.111z"
              stroke="#fff"
              strokeMiterlimit={10}
              strokeLinecap="round"
            />
          </g>
          <defs>
            <filter
              id="filter3_concave"
              x={0}
              y={0}
              width={104}
              height={143.169}
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity={0} result="BackgroundImageFix" />
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation={5} />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2={-1}
                k3={1}
              />
              <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
              <feBlend in2="shape" result="effect1_innerShadow" />
            </filter>
          </defs>
        </>
      ) : (
        <>
          <path
            d="M99.812 130.698c-16.904 16.628-78.72 16.628-95.624 0-10.623-10.449 2.315-34.78 2.315-59.116S-6.435 22.92 4.188 12.472c16.905-16.63 78.72-16.63 95.624 0 10.623 10.448-2.315 34.779-2.315 59.115s12.938 48.657 2.315 59.111z"
            fill={color}
          />
          <path
            d="M52.002 133.714c-18.687 0-35.936-4.156-41.945-10.111-2.705-2.678-.56-13.248 1.332-22.575 1.806-8.906 3.854-18.998 3.854-29.444 0-10.445-2.048-20.537-3.854-29.443-1.892-9.327-4.037-19.897-1.332-22.575C16.066 13.61 33.315 9.455 52.002 9.455s35.937 4.156 41.941 10.11c2.705 2.684.56 13.25-1.331 22.576-1.807 8.906-3.855 18.998-3.855 29.444 0 10.445 2.048 20.537 3.855 29.443 1.89 9.327 4.036 19.897 1.331 22.575-6.004 5.955-23.254 10.111-41.94 10.111z"
            fill="#fff"
            stroke={color}
            strokeMiterlimit={10}
            strokeLinecap="round"
          />
        </>
      )}
    </svg>
  )
}

export default SvgComponent
